<template>
  <div class="to-pay body">
    <div
      class="goods-msg"
      v-for="(n, index) in dataList"
      :key="index"
    >
      <div class="goods-image">
        <img :src="n.image" />
      </div>
      <div class="goods-msg-inset">
        <el-table
          :data="msgList[index]"
          align="center"
          style="width: 900px"
        >
          <el-table-column
            align="center"
            prop="name"
            label="商品"
            width="250"
          >
          </el-table-column>
          <el-table-column
            prop="price"
            align="center"
            label="限定特価"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="num"
            align="center"
            label="数量"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="小計"
          >
            <template slot-scope="scope">
              {{ scope.row.num * scope.row.price }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="address-msg">
      <div>
        住所: {{ address.city }} {{ address.country }} {{ address.address }} 
      </div>
      <div>
        氏名:{{ address.name }} <span></span> 電話番号:{{ address.phone }} <span></span> E-mail:{{ address.email }}
      </div>
    </div>
    <!-- <button
      class="pay"
      @click="pay()"
    >
      Paypalでのお払い
    </button> -->
    <PayPal
    :amount="price" 
    currency="USD"
    locale="ja_JP"
    :custom="orderId"
    :client="credentials" 
    env="production" 
    :button-style="buttonStyle" 
    @payment-authorized="paymentAuthorized"
    @payment-completed="paymentCompleted"
    @payment-cancelled="paymentCancelled"
    class="pay-btn"
    >
    </PayPal>
    <el-dialog :visible.sync="dialogTableVisible" @close="gomian">
      <div class="dialog">
        <div class="dialog-img">
          <img :src="cheng"/>
        </div>
        <div class="dialog-title" style="margin-top:-20px">
          <span class="cheng">支払い成功</span>
        </div>
        <div class="conter" style="margin-top:75px">
          <div class="conter-d" style="width:40%">
            <div class="size-20">注文番号</div>
            <div class="size-26">{{orderId}}</div>
          </div>
          <div class="conter-d border-le-ri" style="width:30%">
            <div class="size-20">支払い金額</div>
            <div class="size-26 color">USD{{price}}</div>
          </div>
          <div class="conter-d" style="width:30%">
            <div class="size-20">注文日</div>
            <div class="size-26">{{time}}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogTableVisible2">
      <div class="dialog" style="height:674px">
        <div class="dialog-img">
          <img :src="shibai"/>
        </div>
        <div class="dialog-title" style="margin-top:-20px;">
          <span class="shibai">支払いに失敗しました</span>
        </div>
        <div class="conter" style="margin-top:75px;height:110px;">
          <div class="conter-d" style="width:37%">
            <div class="size-20">注文番号</div>
            <div class="size-26 order">{{orderId}}</div>
          </div>
          <div class="conter-d border-le-ri" style="width:32%">
            <div class="size-20">支払い金額</div>
            <div class="size-26 color">USD{{price}}</div>
          </div>
          <div class="conter-d" style="width:31%">
            <div class="size-20">注文日</div>
            <div class="size-26">{{time}}</div>
          </div>
        </div>
        <div class="dialog-btn" style="margin-top:75px;">
          <div @click="dialogTableVisible2=false">
            <span>もう一度支払う</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import PayPal from 'vue-paypal-checkout'
import { cheng , shibai } from '../../../images/buy/index'
export default {
  components: {
    PayPal,
  },
  data () {
    return {
      dataList: [],
      price: "0",
      time: '2020-11-3',
      address: {
        code: null,
        country: null,
        city: null,
        address: null,
        name: null,
        phone: null,
        email: null
      },
      cheng,
      shibai,
      dialogTableVisible:false,
      dialogTableVisible2:false,
      num: 0,
      orderId:'',
      addressId:0,
      msgList: [],
      credentials: {
        //sandbox: 'ARQOi_D9r22F0OrqiZ385hdA10ZaRDVL9R5zikTPTcOMcfNfcNNMN01W0KGBDvTDzQsvSqDD04dJZog4',
        production:'AWYRkj3QjD-ZLebAmfcxTzIMwju6uapTDKrHf7Mwfo5Tno3R3WhEmzTb5IDJC_7IzmDvc3Hsc18RpeRA'
      },
        
      buttonStyle: {
        label: 'pay', // checkout | credit | pay
        size:  'responsive',    // small | medium | responsive
        shape: 'rect',     // pill | rect
        color: 'blue'      // gold | blue | silver
      }
    }
  },
  methods: {
    init () {
      let data = JSON.parse(localStorage.getItem('orderMsg'))
      console.log(data)
      this.dataList = data.goodsMsg
      let msgList = []
      this.dataList.forEach((n, index) => {
        this.price = (this.dataList[0].price * this.dataList[0].num) + ".00"
        this.num = this.dataList[0].num
        msgList[index] = [
          n
        ]
      })
      this.addressId = localStorage.getItem('addressId')
      this.msgList = msgList
      this.address = data.address
      this.formatDate()
      this.pay()
    },
    formatDate() {
      let date = new Date();
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日
      this.time = `${year}-${month}-${day}`;
    },
    pay(){
      let date = {
        methods : 'add',
        type: 3,
        productId:'17',//产品id
        addressId: this.addressId,//地址id
        price: this.price,
        num: this.num
      }
      this.$axios({
         method:'post',
         url:'http://203.85.72.1/forcecms_zhongyin20180515/jdirect/saveOrder',
         headers: {
           'Content-Type': 'application/json',//设置请求头请求格式为JSON
         },
         params:date
      }).then((res)=>{
        this.orderId = res.data.orderId
      })
    },
    gomian(){
      this.$router.go(0)
    },
    paymentAuthorized (data) {
    // 授权完成的回调，可以拿到订单id
      console.log(data);
    },
  
    paymentCompleted (data) {
    // 用户支付完成的回调，可以拿到订单id
    console.log("用户成功支付  回调")
    console.log(data);
      let param = {
          method:"translatorCallback",
          orderId: this.orderId
        }
        this.$axios({
         method:'post',
         url:'http://203.85.72.1/forcecms_zhongyin20180515/h5/managerPay',
         headers: {
           'Content-Type': 'application/json',//设置请求头请求格式为JSON
         },
         params:param
      }).then((res)=>{ 
        this.dialogTableVisible = true
        console.log(res)
      })
    },
  
    paymentCancelled (data) {
    // 用户取消交易的回调
    console.log("用户取消交易回调")
    console.log(data);
    this.dialogTableVisible2 = true
    },
    mounted () {
    }
  }
}
</script>
<style scoped>
.to-pay {
  width: 1100px;
  margin: 0 auto;
}

.goods-msg {
  display: flex;
  padding: 20px 0;
  border-top: solid 1px #ddd;
  border-bottom: solid 1px #ddd;
  margin-bottom: 50px;
}
.goods-image {
  width: 200px;
}
.goods-image img {
  display: block;
  width: 200px;
}
* >>> .el-table td,
* >>> .el-table th {
  padding: 20px 0;
}
* >>> .el-table .cell {
  font-size: 20px;
}
.goods-msg-inset {
  padding-top: 50px;
}
.address-msg {
  width: 1096px;
  box-sizing: border-box;
  padding: 0 auto;
  background: #ffffff;
  border: 2px solid #39d8cc;
  box-shadow: 0px 1px 40px 0px rgba(57, 216, 204, 0.24);
  border-radius: 6px;
  margin-bottom: 40px;
  padding: 40px;
  font-size: 22px;
}
.address-msg span {
  display: inline-block;
  width: 80px;
}
.pay {
  width: 382px;
  height: 68px;
  margin: 0 auto;
  background: #39d8cc;
  box-shadow: 0px 1px 22px 0px rgba(4, 208, 193, 0.56);
  border-radius: 6px;
  text-align: center;
  color: #fff;
  font-size: 30px;
  margin-bottom: 40px;
  border: none;
  outline: none;
  display: block;
}
.pay-btn {
  width: 382px;
  height: 68px;
  margin: 0 auto;
  border-radius: 6px;
  text-align: center;
  color: #fff;
  font-size: 30px;
  margin-bottom: 40px;
  border: none;
  outline: none;
  display: block;
}
.dialog{
  width: 100%;
  height: 546px;
  text-align: center;
  margin: 0 auto;
}
.dialog-title .cheng{
  font-size: 36px;
  font-family: Kozuka Gothic Pr6N;
  font-weight: normal;
  color: #04DFCE;
}
.dialog-title .shibai{
  font-size: 36px;
  font-family: Kozuka Gothic Pr6N;
  font-weight: normal;
  color: #FC4A5B;
}
.conter .conter-d{
   float: left;
   width: 33.3%;
}
.conter .border-le-ri{
  border-left: 1px dashed #BDBDBD;
  border-right: 1px dashed #BDBDBD;
}
.conter-d .size-20{
  font-size: 20px;
  font-family: Kozuka Gothic Pr6N;
  font-weight: normal;
  color: #000000;
  line-height: 62px;
}
.conter-d .size-26{
  font-size: 26px;
  font-family: Kozuka Gothic Pr6N;
  font-weight: normal;
  color: #000000;
  line-height: 49px;
}
.conter-d .order{
  font-size: 23px;
}
.conter-d .color{
  color: #F1840E;
}
.dialog-btn div{
  width: 580px;
  height: 73px;
  background: #04DFCE;
  border-radius: 6px;
  margin: 0 auto;
  cursor:pointer;
}
.dialog-btn span{
  font-size: 30px;
  font-family: Kozuka Gothic Pr6N;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 70px;
}
</style>


// WEBPACK FOOTER //
// src/components/buy/modules/topay.vue